<template>
 <div >
   <q-card-section>
    <div class="text-h5 text-green-14">Dados Beneficiário</div>
   </q-card-section>
   <q-card-section>
        <div class="row q-gutter-lg q-pr-md q-pb-md">
           <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input  type="number" label = "Matrícula" v-model="dadosBeneficiario.matricula"  outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"  />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input label="Plano Previdência" v-model="dadosBeneficiario.planoPrevidenciario" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
          </div>
           <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input  label="Situação Previdenciária" v-model="dadosBeneficiario.situacaoPrevidenciaria" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2">
              <b-input-cpf  label="CPF" v-model="dadosBeneficiario.identificacaoFiscal" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
          </div>
           <div class="col-xs-12 col-sm-12 col-md-3">
              <q-input  label="Nome" v-model="dadosBeneficiario.nome" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
          </div>
            <div class="col-xs-12 col-sm-12 col-md-2">
              <q-input  label="Data de Nascimento" v-model="dadosBeneficiario.dataNascimento" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
           </div>
            <div class="col-xs-12 col-sm-12 col-md-2">
              <b-input-currency label="Benefício Previdenciário Suplementação" v-model="dadosBeneficiario.beneficiarioPrevidenciarioSuplementacao" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
           </div>
            <div class="col-xs-12 col-sm-12 col-md-2">
              <b-input-currency label="Valor Contribuição" v-model="dadosBeneficiario.valorContribuicao" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
           </div>
            <div class="col-xs-12 col-sm-12 col-md-2">
              <b-input-currency label="Beneficiário Líquido" v-model="dadosBeneficiario.beneficioLiquido" outlined :dense="true" lazy-rules :rules="[vRequired]" :readonly="true"/>
           </div>
      </div>
   </q-card-section>
</div>
</template>
<style>
</style>

<script>
export default {
  props: {
    dadosBeneficiario: {
      required: true
    }
  }
}
</script>
